<div class="around">
    <i class="fal fa-times close-btn" title="Đóng" (click)="close()"></i>
    <label class="layer-label">Basemap</label>
    <ul class="esri-basemap-gallery__item-container" role="menu">
        <li aria-selected="false" class="mt-0 esri-basemap-gallery__item {{ style.base ? 'esri-basemap-gallery__item--selected' : '' }}" *ngFor="let style of baseLayerStyles" title="{{ style.title }}" (click)="setStyle(style)">
            <div class="item-wrapper">
                <img alt="" class="esri-basemap-gallery__item-thumbnail" src="{{ style.img }}">
                <div class="esri-basemap-gallery__item-title">{{ style.title }}</div>
            </div>
        </li>
    </ul>
</div>
